import { unsafeCSSVarV2 } from '@blocksuite/affine-shared/theme';
import { css } from 'lit';

import { DRAG_HANDLE_CONTAINER_WIDTH } from './config.js';

export const styles = css`
  :host {
    pointer-events: none !important;
  }

  .affine-drag-handle-widget {
    display: flex;
    position: absolute;
    left: 0;
    top: 0;
    contain: size layout;
  }

  .affine-drag-handle-container {
    top: 0;
    left: 0;
    position: absolute;
    display: flex;
    justify-content: center;
    width: ${DRAG_HANDLE_CONTAINER_WIDTH}px;
    min-height: 12px;
    pointer-events: auto;
    user-select: none;
    box-sizing: border-box;
  }
  .affine-drag-handle-container:hover {
    cursor: grab;
  }

  .affine-drag-handle-grabber {
    width: 4px;
    height: 100%;
    border-radius: 1px;
    background: var(--streamlain-placeholder-color);
    transition: width 0.25s ease;
  }

  .affine-drag-handle-grabber.dots {
    width: 14px;
    height: 26px;
    box-sizing: border-box;
    padding: 5px 2px;
    border-radius: 4px;
    gap: 2px;
    display: flex;
    flex-wrap: wrap;
    background-color: transparent;
    transform: translateX(-100%);
    transition: unset;
  }

  .affine-drag-handle-grabber.dots:hover {
    background-color: ${unsafeCSSVarV2('layer/background/hoverOverlay')};
  }

  .affine-drag-handle-grabber.dots > .dot {
    width: 4px;
    height: 4px;
    border-radius: 50%;
    flex: 0 0 4px;
    background-color: ${unsafeCSSVarV2('icon/secondary')};
  }

  .affine-edgeless-drag-handle {
    position: absolute;
    z-index: 4;
    display: grid;
    grid-template-columns: repeat(3, 4px);
    grid-template-rows: repeat(2, 4px);
    gap: 3px 4px;
    place-content: center;
    width: 46px;
    height: 22px;
    padding: 0;
    border: 1px solid ${unsafeCSSVarV2('layer/insideBorder/border')};
    border-radius: 12px;
    color: ${unsafeCSSVarV2('icon/secondary')};
    background: ${unsafeCSSVarV2('layer/background/primary')};
    box-shadow: 0 2px 8px rgb(0 0 0 / 16%);
    cursor: grab;
    font-size: 0;
    line-height: 0;
    pointer-events: none;
    opacity: 0;
    transform: translate(-50%, -100%)
      rotate(var(--edgeless-drag-handle-rotate, 0deg)) scale(0.86);
    transform-origin: center bottom;
    transition:
      opacity 140ms ease,
      transform 140ms ease;
    touch-action: none;
  }

  .affine-edgeless-drag-handle[data-visible='true'] {
    pointer-events: auto;
    opacity: 1;
    transform: translate(-50%, -100%)
      rotate(var(--edgeless-drag-handle-rotate, 0deg)) scale(1);
  }

  .affine-edgeless-drag-handle:active {
    cursor: grabbing;
  }

  .affine-edgeless-drag-handle > .dot {
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: currentColor;
    pointer-events: none;
  }

  @media print {
    .affine-drag-handle-widget {
      display: none;
    }
  }
  .affine-drag-hover-rect {
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 6px;
    background: var(--streamlain-hover-color);
    pointer-events: none;
    z-index: 2;
    animation: expand 0.25s forwards;
  }
  @keyframes expand {
    0% {
      width: 0;
      height: 0;
    }
  }
`;
